<script>
import { Switch } from 'ant-design-vue'
export default {
  props: ['item', 'value', 'mode'],
  mounted() {
    if (this.value == null) {
      this.onChange('1')
    }
  },
  methods: {
    onChange(data) {
      if (this.item.onChange) {
        this.item.onChange(data)
      }
      if (this.item.reversal) {
        this.$emit('change', data ? '1' : '0')
      } else {
        this.$emit('change', data ? '0' : '1')
      }
    },
    getChecked() {
      if (this.item.reversal) {
        return this.value == '1'
      } else {
        return this.value == '0'
      }
    },
    getDefaultChecked() {
      if (this.item.reversal) {
        return this.value == '1'
      } else {
        return this.value == '0'
      }
    },
  },
  render() {
    return (
      <Switch
        disabled={this.mode == 'detail' || this.item.disabled}
        checked={this.getChecked()}
        defaultChecked={this.getDefaultChecked()}
        onChange={(data) => this.onChange(data)}
        checked-children={this.item.showText ? this.item.showText[0] : ''}
        un-checked-children={this.item.showText ? this.item.showText[1] : ''}
      />
    )
  },
}
</script>
